import { Injectable } from '@angular/core';
@Injectable()
export class VehicleInfo {
  year?: string;
  make?: string;
  model?: string;
}
